import React, { Component } from "react";
import ListRatings from "../components/ListRatings";

class Rating extends Component {
  render() {
    return (
      <div className="container">
        <ListRatings />
      </div>
    );
  }
}
 
export default Rating;